import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
export var returnWrapper = function returnWrapper(awaitable) {
  return {
    promise: awaitable || Promise.resolve()
  };
};